import styled from 'styled-components';

export const GridContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 12px;
  padding: 24px 16px 16px;
`;

export const GridTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.element.primary};
  margin: 0 0 16px 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

export const Tile = styled.div<{ $disabled?: boolean }>`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 12px;
  padding: 16px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  height: 181px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  transition: box-shadow 0.15s;

  ${({ $disabled }) =>
    !$disabled &&
    `&:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    }`}
`;

export const TileTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const TileIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.brand.primary};

  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.colors.brand.primary};
  }
`;

export const TileTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.element.primary};
  line-height: 20px;
  max-width: calc(100% - 32px);
`;
